import { Controller } from "@hotwired/stimulus"
import { patch, get, post } from '@rails/request.js'
import { 
  email_path, content_email_path, signature_mailbox_path,
  emails_path
} from "../routes"

export default class extends Controller {
  static values = {
    id: Number
  }
  static targets = ["copyfrom", "content", "emailList", "indexToolbar"]
  static outlets = ["email-toolbar"]

  connect() {
    if (this.hasEmailListTarget) {
      console.log("hasEmailListTarget")
      this.emailListTarget.addEventListener('change', async (event) => {
        if (event.target.type === 'checkbox') {
          const selectedEmails = Array.from(this.emailListTarget.querySelectorAll('input[type="checkbox"]:checked'));
          if (selectedEmails.length > 0) {
            this.emailToolbarOutlet.idsValue = selectedEmails.map((email) => email.value);
            this.showMultipleActionsToolbar(event);
          } else {
            this.showOriginalActionsToolbar(event);
          }
        }
      });
    }
    else if (this.hasEmailToolbarOutlet) {
      console.log("hasEmailToolbarOutlet")
      const checkboxes = this.element.querySelectorAll('input[name="email_id"][type="checkbox"]');
      const checkedItems = this.emailToolbarOutlet.idsValue;
      checkboxes.forEach((checkbox) => {
        if (checkedItems.includes(checkbox.value)) {
          checkbox.checked = true;
        }
      });
    }
  }

  disconnect() {
    if (this.hasEmailListTarget) {
      this.emailListTarget.removeEventListener('change');
    }
  }

  showMultipleActionsToolbar(event) {
    this.emailToolbarOutlet.showMultipleActionsToolbar(event);
  }

  showOriginalActionsToolbar(event) {
    this.emailToolbarOutlet.showOriginalActionsToolbar(event);
  }

  changeTaskView(event) {
    let querystring = []; 
    if (document.getElementById("all_emails").checked) {
      querystring.push("all_emails=true")
    } else {
      querystring.push("all_emails=false")
    }

    Turbo.visit('/emails?'+querystring.join('&'), { frame: "table_content" })
  }

  clearForm() {
    document.getElementById("model_searchform").querySelector("#clear").value = 1;
    document.getElementById("model_searchform").setAttribute("data-turbo", "false");
    document.getElementById("model_searchform").requestSubmit();

  }

  async changeStatus(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { status: event.params.status }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async seen(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { seen: true }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async unseen(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { seen: false }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async archive(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { tags_attributes: [ { tag: "archive" } ] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async unarchive(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { email_tag_connections_attributes: [ { id: event.params.tagId, _destroy: true } ] } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async delete(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { tags_attributes: [ { tag: "trash" } ] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async undelete(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { email_tag_connections_attributes: [ { id: event.params.tagId, _destroy: true } ] } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async changeResponsible(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { responsible_id: event.params.responsibleId }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async expand(event) {
    if (document.getSelection().type == "Range") return;
    const response = await get(content_email_path(this.idValue, "expanded"), {
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async collapse(event) {
    if (document.getSelection().type == "Range") return;
    const response = await get(content_email_path(this.idValue, "collapse"), {
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async changeTag(event) {
    let attr = {}

    let item = event.target.querySelector("input")
    if (item.checked) {
      attr = { email_tag_id: item.value, _destroy: true }
    } else {
      attr = { email_tag_id: item.value }
    }

    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { email_tag_connections_attributes: [attr] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async newtag(event) {
    const response = await patch(email_path(this.idValue), {
      body: {id: this.idValue, email: { email_tag_connections_attributes: { email_tag_attributes: { tag: event.target.value } } } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  added_attachment(event) {
    const originalElement = this.copyfromTarget
    const clone = originalElement.cloneNode(true)
    const originalFileInput = originalElement.querySelector('input[type="file"]')
    if (originalFileInput) {
      originalFileInput.removeAttribute('data-action')
    }
    const fileInput = clone.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.value = ''
    }
    originalElement.parentNode.insertBefore(clone, originalElement.nextSibling)
  }

  async get_signature(event) {
    const response = await get(signature_mailbox_path(event.target.value, 'html'), {
      responseKind: "html"
    })
    if (response.ok) {
      const data = await response.text
      //document.getElementById(this.contentTarget.id).activeEditor.setContent("<br/><br/>"+data)
      tinymce.activeEditor.setContent("<br/><br/>"+data)
    }
  }
}
